import React from 'react';
import styles from './PrivacyPolicy.module.css';
import { PRIVACY_POLICY } from '../../constants/config';

const PrivacyPolicy = ({ onBackClick }) => {
  return (
    <div className={styles.privacyPolicy}>
      <div className={styles.container}>
        <div className={styles.headerSection}>
          {/* <button className={styles.backButton} onClick={onBackClick}>
            ← Назад
          </button> */}
          <h1>Политика конфиденциальности</h1>
        </div>
        
        {PRIVACY_POLICY.sections.map((section, index) => (
          <section key={index}>
            <h2>{section.title}</h2>
            <p>{section.content}</p>
            {section.list && (
              <ul>
                {section.list.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className={styles.lastUpdated}>
          <p>Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
